// FollowerSection.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Badge,
  Input
} from "reactstrap";
import { withTranslation } from "react-i18next";

import { Plus, List } from 'lucide-react';

import FollowerCard from './components/FollowerCard';

import { useSelector, useDispatch } from "react-redux";

import { uploadImage, fetchImage } from "utils/images/imageManager";

import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import axiosInstance from "utils/axiosInstance";


const FollowerSection = ({ t, myInfoProfile }) => {

  const dispatch = useDispatch();

  const { 
    followers, 
    loading: followerLoading, 
    error: dataFetchError 
  } = useSelector(state => state.followers);
  const imageMap = useSelector(state => state.imageMap);

  useEffect(() => {
    dispatch({ type: "FOLLOWERS_FETCH_REQUEST" });
  }, [dispatch]);

  //--------------------------------------------------
  // Return
  //--------------------------------------------------

  return (
    <div className="d-block">
      <Row style={{ paddingLeft: "25px", marginBottom: "18px" }}>
        <Col className="info-profile-carousel-col">
          <div className="d-flex justify-content-between align-items-center info-profile-section-header">
            <div className="d-flex align-items-center">
              <p className="mb-0 me-2 info-profile-section-title">追蹤者</p>
              <span style={{ fontSize: '16px', color: '#6c757d' }}>{`(${followers.length || 0})`}</span>
            </div>
          </div>
        </Col>
      </Row>

      <Container style={{ padding: "5px 20px" }}>
        {followerLoading && followers.length === 0 && <p>Loading...</p>}
        {dataFetchError && <p className="text-danger">{dataFetchError}</p>}
        {followers.length === 0 && !followerLoading && <p>目前沒有追蹤者</p>}

        <div className="followers-grid">
          {followers.map((follower, idx) => (
            <div key={idx} className="followers-grid-item">
              <FollowerCard
                follower={follower}
                imageUrl={imageMap[follower.profileImage] || placeholder_image}
              />
            </div>
          ))}
        </div>
      </Container>

    </div>
  );
};

export default withTranslation()(FollowerSection);


